import React, { useContext, useEffect, useState } from "react";
import { Form, Checkbox } from "antd";
import { cardiovascularOptions } from "../../Options/clinicalImpressionOptions";
import DynamicInputFields from "../../../../blocks/FormItems/DynamicInputFields";

const CardioVascular = ({ context, form }) => {
  const { formData } = useContext(context);
  const cardioVascularData =
    formData?.clinical_diagnosis?.cardiovascular_diagnosis ||
    formData?.cardiovascular_diagnosis;
  const [showCardioVascularOthers, setShowCardioVascularOthers] = useState(
    cardioVascularData?.includes("others")
  );

  const handleCardioVascularChange = (selectedOptions) => {
    setShowCardioVascularOthers(selectedOptions?.includes("others"));
  };

  useEffect(() => {
    setShowCardioVascularOthers(cardioVascularData?.includes("others"));
  }, [formData]);

  return (
    <>
      <Form.Item name="cardiovascular_diagnosis" label="CardioVascular">
        <Checkbox.Group
          options={cardiovascularOptions}
          onChange={handleCardioVascularChange}
        />
      </Form.Item>
      {showCardioVascularOthers && (
        <DynamicInputFields
          field_key={"cardiovascular_others"}
          form={form}
          inputStyle={{ maxWidth: 800 }}
        />
      )}
    </>
  );
};

export default CardioVascular;
